export enum NotificationType {
    DataCheckinJob = 'DataCheckinJob',
    Workflow = 'Workflow',
}
